import { useContext, useMemo } from 'react';
import { ServerContext } from '@bingads-webui-campaign-react/server-context';

export const useIsReadOnlyUser = (): boolean => {
  const serverContext = useContext(ServerContext) as any;
  return useMemo(() => (serverContext?.CurrentAccountInActive || serverContext?.Permissions?.IsReadOnlyUser), [serverContext]);
};
